interface RewindButtonSVGProps {
  color: string;
  style: React.CSSProperties;
}

const RewindButtonSVG = ({ color, style }: RewindButtonSVGProps) => (
  <svg
    style={style}
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="60"
      cy="60"
      r="56.3636"
      stroke="#D9D9D9"
      strokeWidth="7.27273"
    />
    <path
      d="M33 64.5C33 69.8401 34.5835 75.0603 37.5503 79.5004C40.5171 83.9405 44.7339 87.4012 49.6675 89.4447C54.6012 91.4883 60.03 92.023 65.2674 90.9812C70.5049 89.9394 75.3159 87.3679 79.0919 83.5919C82.8679 79.8159 85.4394 75.0049 86.4812 69.7674C87.523 64.5299 86.9883 59.1012 84.9447 54.1675C82.9012 49.2339 79.4405 45.0171 75.0004 42.0503C70.5603 39.0835 65.3401 37.5 60 37.5H51V26.25L37.5 39.75L51 53.25V42H60C64.4501 42 68.8002 43.3196 72.5003 45.7919C76.2004 48.2643 79.0843 51.7783 80.7873 55.8896C82.4903 60.001 82.9358 64.525 82.0677 68.8895C81.1995 73.2541 79.0566 77.2632 75.9099 80.4099C72.7632 83.5566 68.7541 85.6995 64.3895 86.5677C60.025 87.4358 55.501 86.9903 51.3896 85.2873C47.2783 83.5843 43.7643 80.7004 41.2919 77.0003C38.8196 73.3002 37.5 68.9501 37.5 64.5H33Z"
      fill={color}
    />
    <path
      d="M68.1666 73.792C67.1724 73.8163 66.1863 73.6083 65.2866 73.1845C64.4878 72.779 63.8003 72.1842 63.2841 71.452C62.7183 70.5977 62.3212 69.643 62.1141 68.6395C61.8483 67.3973 61.72 66.1297 61.7316 64.8595C61.7225 63.5894 61.8508 62.322 62.1141 61.0795C62.3253 60.0772 62.7222 59.1233 63.2841 58.267C63.8003 57.5347 64.4878 56.9399 65.2866 56.5345C66.1863 56.1106 67.1724 55.9026 68.1666 55.927C69.1014 55.8558 70.0389 56.0253 70.8896 56.4191C71.7404 56.813 72.4761 57.4182 73.0266 58.177C74.1869 60.1724 74.7346 62.465 74.6016 64.7695C74.7346 67.0739 74.1869 69.3665 73.0266 71.362C72.497 72.1539 71.7705 72.7943 70.9183 73.2204C70.0662 73.6464 69.1179 73.8434 68.1666 73.792ZM68.1666 71.047C68.6202 71.074 69.0722 70.9722 69.4704 70.7532C69.8686 70.5342 70.1966 70.207 70.4166 69.8095C70.9544 68.757 71.2394 67.5938 71.2491 66.412V63.307C71.2978 62.1465 71.0743 60.9907 70.5966 59.932C70.3451 59.5466 70.0015 59.2301 69.5968 59.011C69.1922 58.7919 68.7393 58.6772 68.2791 58.6772C67.819 58.6772 67.3661 58.7919 66.9614 59.011C66.5568 59.2301 66.2132 59.5466 65.9616 59.932C65.4839 60.9907 65.2605 62.1465 65.3091 63.307V66.412C65.2627 67.5795 65.486 68.7421 65.9616 69.8095C66.1762 70.2017 66.4968 70.5257 66.8867 70.7445C67.2765 70.9633 67.7201 71.0681 68.1666 71.047ZM47.9166 73.4995V70.8445H52.4166V59.167L48.2316 61.417L46.9941 59.032L52.2141 56.107H55.4991V70.732H59.5041V73.4995H47.9166Z"
      fill={color}
    />
  </svg>
);

export default RewindButtonSVG;
